<div class="add-table" id="add-table">
  <form [formGroup]="formAddTable" class="form add-table" (ngSubmit)="Close()">
    <div class="fieldset">
      <label for="name">{{ "add_table.table_name" | translate }}</label>
      <input formControlName="name" pInputText placeholder="{{ 'add_table.table_name' | translate }}"
        style="width: 100%" type="text" />
    </div>
    <div class="double">
      <div class="fieldset">
        <label for="capacity">{{
          "add_table.table_capacity" | translate
          }}</label>
        <p-inputNumber inputId="capacity" formControlName="capacity"
          placeholder="{{ 'add_table.table_capacity' | translate }}" [style]="{ width: '100%' }" [min]="1"
          [max]="100" />
      </div>
      <div class="fieldset">
        <label for="min_limit">{{
          "add_table.table_minimum_capacity" | translate
          }}</label>
        <p-inputNumber inputId="min_limit" formControlName="min_limit"
          placeholder="{{ 'add_table.table_minimum_capacity' | translate }}" [style]="{ width: '100%' }" [min]="1"
          [max]="100" />
      </div>
    </div>
    <div class="buttons">
      <p-button type="submit" [disabled]="formAddTable.invalid" icon="pi pi-check" [label]="
          config.data
            ? translate.instant('edit')
            : translate.instant('add_table.add')
        "></p-button>
    </div>
  </form>
</div>